module.exports = __webpack_public_path__ + "static/media/integration.7bf5cd63.svg";